var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"invoice-loader"},[(_vm.loadingInvoice)?_c('div',[_vm._v("\n      Loading invoice...\n    ")]):(_vm.invoiceValid == false)?_c('div',{staticClass:"text-center"},[_vm._v("\n      Invoice not found. "),_c('br'),_vm._v("Please double check the URL you entered.\n    ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }